import React, { useState, useEffect, useContext, useRef } from 'react';
import {
  SocialMediaHeroPage,
  YouTubeChannel,
  EducationalPost,
  JoinUs,
  OSPCarousel,
  BTSCarousel,
  ShowsPodcast,
  SubscribeFundamentalPackage,
} from "../../Component";
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
import { useScrollToTopWithDelay } from '../../hooks';
import styles from "./SocialMediaPage.module.css";
import {
  LanguageProvider,
  HomePageProvider,
  AboutusPageContext,
  AboutusPageProvider,
  SocialMediaPageContext, 
  SocialMediaPageProvider
} from "../../store";

export default function SocialMediaPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const contentRef = useRef(null);

  useScrollToTopWithDelay(1000);

  const { aboutusScreenDetails, loading: aboutLoading } = useContext(AboutusPageContext);
  const { socialMediaPageDetails, loading: socialMediaLoading } = useContext(SocialMediaPageContext);

  // Handle initial loading and data fetching
  useEffect(() => {


    const checkLoading = () => {
      if (!aboutLoading && 
          !socialMediaLoading && 
          data.length > 0 && 
          document.readyState === 'complete' &&
          imagesLoaded) {
        setTimeout(() => {
          setLoading(false);

        }, 2000);
      }
    };

    checkLoading();

    // Fallback to hide loader after 5 seconds
    const fallbackTimer = setTimeout(() => {
      if (loading) {
 
        setLoading(false);
      }
    }, 5000);

    return () => clearTimeout(fallbackTimer);
  }, [aboutLoading, socialMediaLoading, data, imagesLoaded]);

  // Check if all images are loaded
  useEffect(() => {
    if (contentRef.current) {
      const images = contentRef.current.getElementsByTagName('img');
      let loadedImages = 0;
      const totalImages = images.length;



      const imageLoaded = () => {
        loadedImages++;

        if (loadedImages === totalImages) {
          setImagesLoaded(true);

        }
      };

      if (totalImages === 0) {
        setImagesLoaded(true);
        return;
      }

      Array.from(images).forEach(img => {
        if (img.complete) {
          imageLoaded();
        } else {
          img.addEventListener('load', imageLoaded);
          img.addEventListener('error', imageLoaded);
        }
      });

      return () => {
        Array.from(images).forEach(img => {
          img.removeEventListener('load', imageLoaded);
          img.removeEventListener('error', imageLoaded);
        });
      };
    }
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const ids = [
          "6718a77450f2b77b4e3a82da",
          "6718aad58184b043b1f4ce00",
          "6718b8968184b043b1f4ce03",
          "6718b9848184b043b1f4ce04",
          "6718bfec9dc465cbed798603",
          "6718be339dc465cbed7985ff"
        ];

        const url = `${marketingBackendUrl}/maflam/get-data-by-ids?${ids.map(id => `ids=${id}`).join("&")}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        setData(result.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err.message);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className={styles.loaderWrapper}>
        <span className={styles.loader}></span>
      </div>
    );
  }

  if (error) return <p>Error: {error}</p>;

  return (
    <LanguageProvider>
      <HomePageProvider>
        <AboutusPageProvider>
          <SocialMediaPageProvider>
            <div className={styles.bgContainer} ref={contentRef}>
              {data[0] && <SocialMediaHeroPage firstData={data[0]} />}
              {data[1] && <OSPCarousel secondData={data[1]} />}
              {data[2] && <ShowsPodcast secondData={data[2]} />}
              {data[3] && <YouTubeChannel thirdData={data[3]} />}
              {data[4] && <EducationalPost fifthData={data[4]} />}
              {data[5] && <BTSCarousel sixthData={data[5]} />}
            </div>
          </SocialMediaPageProvider>
        </AboutusPageProvider>
      </HomePageProvider>
    </LanguageProvider>
  );
}